//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            loading: true,
            resident: {},
            transactions: [],
            deposit_amount: '',
            balance: 0,
            vendor: '',
            number: '',
            vendors: [],
            invoice: {}
        };
    },
    created: function created() {
        Event.$on('refund-preview', this.refundPreview);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('refund-preview');
    },
    mounted: function mounted() {},


    methods: {
        refundPreview: function refundPreview(resident) {
            var $el = this;

            $el.loading = true;
            $el.resident = resident;
            $el.deposit_amount = resident.unit.unit_lease.resident_deposit_amount;
            $el.$children[0].$data.showModal = true;
            axios.post('/prototype/resident/ledger/balance', { id: $el.resident.id }).then(function (response) {
                return $el.balance = response.data;
            });
            axios.post('/prototype/resident/ledger', { id: $el.resident.id }).then(function (response) {
                if (response.data) {
                    $el.loading = false;
                    $el.transactions = response.data.transactions;
                }
            });
            axios.get('/prototype/vendors/all').then(function (response) {
                response.data.map(function (vendor) {
                    return vendor.name = vendor.id + ': ' + vendor.name;
                });
                $el.vendors = response.data;
            });
        },
        close: function close() {
            Event.$emit('close-full-modal');
        },
        createInvoice: function createInvoice() {
            var $el = this;
            this.invoice.vendor_id = this.vendor ? this.vendor.id : '';
            this.invoice.number = this.number;
            this.invoice.resident_id = this.resident.id;
            this.invoice.amount = this.finalAmount;
            axios.post('/prototype/accounting/accounts-payable/invoice/refund-invoice', { invoice: this.invoice }).then(function (response) {
                if (response.data.code && response.data.code == 219) {
                    var notify = (response.data.msg.number ? response.data.msg.number : '') + "\n" + (response.data.msg.vendor_id ? response.data.msg.vendor_id : '');
                    $el.$snotify.error(notify);
                } else {
                    Event.$emit('close-full-modal');
                    $el.$snotify.success('The invoice was saved');
                    Event.$emit('resident-list-dashboard-updated');
                }
            });
        }
    },

    computed: {
        finalAmount: function finalAmount() {
            var $el = this;
            return Number.parseFloat($el.deposit_amount - $el.balance);
        },
        finalAmountReceivable: function finalAmountReceivable() {
            var $el = this;
            return Math.abs(Number.parseFloat($el.deposit_amount - $el.balance));
        }
    }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/ResidentRefundPreview.vue
// module id = VUq+
// module chunks = 0 1